import {connect} from "react-redux"
import State from "../../ducks/state"

export const mapStateToProps = (state: State) => {
    const {siteUrl} = state.request
    const {meganavCircularIconsEnabled} = state.settings

    return {
        siteUrl,
        meganavCircularIconsEnabled,
    }
}

export default connect(mapStateToProps)
